import { render, staticRenderFns } from "./Tab-Distribution-Center.vue?vue&type=template&id=a63d92a2"
import script from "./Tab-Distribution-Center.vue?vue&type=script&lang=js"
export * from "./Tab-Distribution-Center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports